let _client

const validator = {
    isValid (postalCode) {
        return _client.post(
            `${process.env.VUE_APP_API_URL}/verify/postal-code`,
            { 'postal_code': postalCode }
        ).then(
            res => res.status === 200,
            () => false
        )
    }
}

export const geolocationService = (client) => {
    _client = client
    return {
        validator
    }
}

